module.exports = __webpack_public_path__ + "images/owl.video.play.png";